export default "__VITE_ASSET__Hjc$noNB__";